<!-- A tiny picture and one sentence for each mechanic, shown on the pre-round
     card the first time it appears. Inline SVG using the palette tokens. -->
<template>
  <div class="play-card__mech">
    <svg viewBox="0 0 56 56" aria-hidden="true">
      <template v-if="id === 'bauble'">
        <circle cx="28" cy="30" r="14" class="f-bauble" />
        <rect x="24" y="10" width="8" height="6" rx="2" class="f-gold" />
        <path d="M30 22 L24 31 H29 L26 39 L33 29 H28 Z" class="f-white" />
      </template>
      <template v-else-if="id === 'star'">
        <path d="M28 8 L33 21 L47 22 L36 31 L40 45 L28 37 L16 45 L20 31 L9 22 L23 21 Z" class="f-star" />
        <rect x="8" y="48" width="40" height="4" rx="1" class="f-meter" />
      </template>
      <template v-else-if="id === 'tangled'">
        <path d="M6 28 C14 12, 22 44, 30 28 S 46 12, 50 28" class="s-tangle" />
        <path d="M22 26 C26 18, 30 38, 34 30 S 28 20, 24 32" class="s-tangle" />
      </template>
      <template v-else-if="id === 'bell'">
        <path d="M16 38 C16 22, 22 16, 28 14 C34 16, 40 22, 40 38 Z" class="f-gold" />
        <rect x="13" y="38" width="30" height="4" rx="1" class="f-gold" />
        <circle cx="28" cy="45" r="3" class="f-ink" />
        <circle cx="28" cy="11" r="3" class="f-gold" />
      </template>
      <template v-else-if="id === 'golden'">
        <path d="M6 30 L50 26" class="s-gold" />
        <circle cx="14" cy="34" r="3" class="f-b1" />
        <circle cx="22" cy="34" r="3" class="f-b2" />
        <circle cx="30" cy="33" r="3" class="f-b3" />
        <circle cx="38" cy="32" r="3" class="f-b4" />
        <circle cx="46" cy="32" r="3" class="f-b5" />
      </template>
      <template v-else-if="id === 'split'">
        <path d="M8 40 L28 28 L48 40 M28 28 L28 12" class="s-cable" />
        <circle cx="28" cy="28" r="6" class="f-junction" />
        <circle cx="14" cy="36" r="5" class="f-spark" />
        <circle cx="42" cy="36" r="5" class="f-spark" />
      </template>
      <template v-else>
        <circle cx="28" cy="28" r="10" class="f-spark" />
      </template>
    </svg>
    <div>
      <strong>{{ info.name }}</strong>
      <p>{{ info.blurb }}</p>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const INFO = {
  bauble: { name: 'Battery Bauble', blurb: 'The spark parks here to charge. Tap Release once the next junction is set and it flies off faster.' },
  star: { name: 'Solar Star', blurb: 'Collect three to fill the Good Energy Meter, then Burst lights every bulb near the spark.' },
  tangled: { name: 'Tangled Lights', blurb: 'A knotted string: slower going and half the points. Switch away at the junction before it.' },
  bell: { name: 'Community Bell', blurb: 'Light the hall and the bell rings: bonus points, and the homes next door light up a little too.' },
  golden: { name: 'Golden Route', blurb: 'Twice the bulbs on a gold cable, and less time to decide at the next junction.' },
  split: { name: 'Double Spark', blurb: 'Two sparks for eight seconds. Both score, and the multiplier doubles.' },
};

const props = defineProps({ id: { type: String, required: true } });
const info = computed(() => INFO[props.id] ?? { name: props.id, blurb: '' });
</script>

<style scoped>
.f-bauble { fill: var(--soc-bauble); }
.f-gold { fill: var(--soc-gold); }
.f-white { fill: var(--soc-white); }
.f-star { fill: var(--soc-star); }
.f-meter { fill: var(--soc-meter); }
.f-ink { fill: var(--soc-sky-top); }
.f-junction { fill: var(--soc-junction); }
.f-spark { fill: var(--soc-spark); }
.f-b1 { fill: var(--soc-bulb-1); }
.f-b2 { fill: var(--soc-bulb-2); }
.f-b3 { fill: var(--soc-bulb-3); }
.f-b4 { fill: var(--soc-bulb-4); }
.f-b5 { fill: var(--soc-bulb-5); }
.s-tangle { fill: none; stroke: var(--soc-tangle); stroke-width: 3; stroke-linecap: round; }
.s-gold { fill: none; stroke: var(--soc-gold); stroke-width: 4; stroke-linecap: round; }
.s-cable { fill: none; stroke: var(--soc-cable-active); stroke-width: 3; stroke-linecap: round; }
</style>
